import {CSSProperties, FC} from 'react';


export interface IIconCalcNissanProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconCalcNissan: FC<IIconCalcNissanProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path fillRule="evenodd" d="M12.552 15.847a.771.771 0 0 0-.124-.087.449.449 0 0 0-.132-.066.494.494 0 0 0-.148-.043.77.77 0 0 0-.444.043.68.68 0 0 0-.42.393.578.578 0 0 0-.062.277.686.686 0 0 0 .055.276c.045.087.102.168.17.24a.807.807 0 0 0 .553.21.692.692 0 0 0 .296-.057.905.905 0 0 0 .256-.153.704.704 0 0 0 .226-.516.689.689 0 0 0-.062-.277.724.724 0 0 0-.164-.24Zm-3.235-2.996a.445.445 0 0 0-.133-.066.48.48 0 0 0-.147-.058.715.715 0 0 0-.304 0l-.14.044-.14.065-.116.088a.738.738 0 0 0-.226.53c-.001.194.08.38.226.517a.905.905 0 0 0 .256.153c.24.092.512.066.727-.068a.716.716 0 0 0 .347-.601.739.739 0 0 0-.226-.517l-.124-.087Zm.124 2.996a.788.788 0 0 0-.257-.152.826.826 0 0 0-.45-.059l-.14.044a.605.605 0 0 0-.14.066c-.041.026-.08.056-.117.087a.724.724 0 0 0-.164.24.643.643 0 0 0 0 .552c.04.089.095.17.164.24a.804.804 0 0 0 .552.226.692.692 0 0 0 .295-.058.905.905 0 0 0 .257-.153.832.832 0 0 0 .163-.24.643.643 0 0 0 0-.553.722.722 0 0 0-.163-.24Zm2.263-3.061a.786.786 0 0 0-.256.152.739.739 0 0 0-.226.516.716.716 0 0 0 .347.602c.215.134.487.16.727.068a.905.905 0 0 0 .256-.153.704.704 0 0 0 .226-.517.739.739 0 0 0-.226-.516.818.818 0 0 0-.848-.152Zm3.96 3.061a.906.906 0 0 0-.257-.152.818.818 0 0 0-.848.152.722.722 0 0 0-.163.24.643.643 0 0 0 0 .553.83.83 0 0 0 .163.24.807.807 0 0 0 .552.21.692.692 0 0 0 .296-.057.905.905 0 0 0 .256-.153.693.693 0 0 0 .164-.793.724.724 0 0 0-.164-.24ZM15.11 6.91H8.89c-.43 0-.778.326-.778.727v2.91c0 .401.348.727.778.727h6.222c.43 0 .778-.326.778-.727v-2.91c0-.401-.348-.727-.778-.727Zm-.778 2.91H9.667V8.363h4.666v1.454ZM16.667 4H7.333C6.045 4 5 4.977 5 6.182v11.636C5 19.023 6.045 20 7.333 20h9.334C17.955 20 19 19.023 19 17.818V6.182C19 4.977 17.955 4 16.667 4Zm.777 13.818c0 .402-.348.727-.777.727H7.333c-.43 0-.777-.325-.777-.727V6.182c0-.402.348-.727.777-.727h9.334c.43 0 .777.325.777.727v11.636Zm-1.905-4.967a.446.446 0 0 0-.132-.066.49.49 0 0 0-.148-.043.715.715 0 0 0-.303 0l-.14.043-.14.066-.117.087a.739.739 0 0 0-.226.516.716.716 0 0 0 .347.602c.215.134.487.16.727.068a.905.905 0 0 0 .256-.153.704.704 0 0 0 .226-.517.739.739 0 0 0-.226-.516l-.124-.087Z" clipRule="evenodd" />
        </svg>
    );
};
